import React, { useEffect, useState } from 'react';
import './banner.css';

interface Banner {
    message: string;
    type: string;
    start?: string;
    end?: string;
}

const BannerNotifications: React.FC = () => {
    const [banners, setBanners] = useState<Banner[]>([]);

    useEffect(() => {
        fetch('/anna/api/v1/banners')
            .then(response => response.json())
            .then((data: Banner[]) => setBanners(data))
            .catch(err => console.error('Error loading banners:', err));
    }, []);

    if (banners.length === 0) return null;

    return (
        <div className="banner-container">
            {banners.map((banner, index) => (
                <div key={index} className={`banner-notification banner-${banner.type || 'info'}`}>
                    {banner.type === 'maintenance' ? (
                        <span>{banner.message}</span>
                    ) : (
                        banner.message
                    )}
                </div>
            ))}
        </div>
    );
};

export default BannerNotifications;
